<template>
    <div class="card-header-actions" style="display: flex; align-items: center; gap: 5px;">
    <b-button
        v-if="chartType !== 'backlog'"
        @click="$emit('emit-last-month')"
        style="min-width: 100px; height: 26px; padding: 0 10px; display: flex; align-items: center; justify-content: center;"
        variant="outline-primary"
      >
        Last 30 days
    </b-button>
    <b-button
      v-if="showDateIcon && chartType !== 'backlog'"
      @click="$emit('emit-date')"
      class
      style="height: 26px; width: 26px"
      variant="transparent p-0"
    >
      <i class="icon-calendar" style="color: #20a8d8;"></i>
    </b-button>
    <b-button
      v-if="showDownloadPdfIcon"
      class="btn"
      style="height: 26px; width: 26px"
      variant="transparent p-0"
      attr="pdf"
      @click="$emit('emit-pdf-download')"
    >
      <LoadingCard
        style=" margin:0 !important; width:26px; height:26px"
        v-if="loadingPdf"
      ></LoadingCard>
      <i
        v-else
        class="fa fa-file-pdf-o"
        style="color: rgb(32, 168, 216);"
        aria-hidden="true"
      ></i>
    </b-button>
    <b-button
      v-if="showDownloadExcelIcon"
      class="btn"
      style="height: 26px; width: 26px"
      variant="transparent p-0"
      attr="excel"
      @click="$emit('emit-excel-download')"
    >
      <LoadingCard
        style=" margin:0 !important; width:26px; height:26px"
        v-if="loadingExcel"
      ></LoadingCard>
      <i
        v-else
        class="fa fa-file-excel-o"
        style="color: rgb(32, 168, 216);"
        aria-hidden="true"
      ></i>
    </b-button>
        <b-button
        v-if="showFullscreenIcon"
        @click="$emit('emit-fullscreen')"
        style="height: 26px; width: 26px"
        variant="transparent p-0"
        right
      >
        <i style="color: #20a8d8;" class="icon-frame"></i>
    </b-button>
  </div>
</template>

<script>
import LoadingCard from "./LoadingCard.vue";

export default {
  name: "HeaderControl",
  props: [
    "showFullscreenIcon",
    "showDateIcon",
    "showDownloadPdfIcon",
    "showDownloadExcelIcon",
    "loadingExcel",
    "loadingPdf",
    "chartType",
  ],
  watch: {
    // loadingExcel() {
    //   console.log(this.loadingExcel);
    // },
    // loadingPdf() {
    //   console.log(this.loadingPdf);
    // }
  },
  components: { LoadingCard }
};
</script>

<style>
.fa .fa-file-pdf-o {
  transform: none;
  font-size: small;
}
</style>
